import { request } from './client';
import { BoardTierConfig } from '../types';

// Admin response includes additional fields
export interface AdminBoardTierConfig extends BoardTierConfig {
  canEdit: boolean;
}

export interface AdminTierConfigsResponse {
  configs: AdminBoardTierConfig[];
}

// API functions
export const tierConfigApi = {
  // Public endpoint - get tier configurations for board creation UI
  getTierConfigs: (): Promise<BoardTierConfig[]> =>
    request('/api/squareup/tier-config'),
};

// Admin API functions
export const adminTierConfigApi = {
  // Get tier configurations with edit permissions
  getTierConfigs: (): Promise<AdminTierConfigsResponse> =>
    request('/api/squareup/admin/tier-config'),

  // Update credit cost for a tier (super_admin only)
  updateTierCost: (numberMode: string, creditCost: number): Promise<BoardTierConfig> =>
    request(`/api/squareup/admin/tier-config/${numberMode}`, {
      method: 'PUT',
      body: { creditCost },
    }),
};
